import {
    SIGNUP,
    SIGNUP_FAILED,
    SIGNUP_SUCCESSFUL
}  from '../constant/index'




export const signinReducer = (
    state = {
        loading: false, signin: []
    }, action
) => {
    switch (action.type) {
        case SIGNUP:
            return {
                loading: true
            }
        case SIGNUP_SUCCESSFUL:
            return {
                loading: false,
                signin: action?.payload
            }
        case SIGNUP_FAILED:
            return {
                loading: false,
                error: true
            }
        default: return state
    }
}